@import '../../scss/mixin';

.label {
  @include srOnly();
}

.textarea {
  appearance: none;
  position: relative;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 38px;
  line-height: 1;
  border: none;
  resize: none;
  border-radius: 0;
  margin: 0;
  padding: 11px 8px 11px 34px;

  font-family: var(--llm-input-font-family);
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.24px;
  background: transparent;
  color: rgba(62, 63, 65, 0.40);
  pointer-events: auto;
  overflow: clip;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &::placeholder {
    font-family: var(--llm-input-font-family);
    font-size: inherit;
    // font-size: 16px;
    // line-height: 1.3;
    color: var(--llm-color-neutral-300);
  }

  &[aria-disabled=true] {
    pointer-events: none;
    color: transparent;
    user-select: none;

    &::placeholder {
      color: transparent;
    }
  }

  field-sizing: content;
}
